import { Document, Category } from 'interfaces/documents';
import { Tooltip } from 'antd';
import WTypography from 'containers/WTypography';
import { useDocumentsDragAndDrop } from '../../../hooks/useDocumentsDragAndDrop';
import { useRef } from 'react';
import { fetchDocuments, refreshDocumentTreeLevels } from 'slices/documentsActions';
import { containingFolderOf } from 'utilities/documentTree';
import { useAppDispatch } from 'utilities/hooks';

export const DocumentTitleDraggable = ({ entity }: { entity: Document | Category}) => {
    const dispatch = useAppDispatch();
    const { drag, drop, active } = useDocumentsDragAndDrop(entity, {
        onMove: (affectedCategories) => {
            dispatch(refreshDocumentTreeLevels(affectedCategories));
            dispatch(fetchDocuments(containingFolderOf(entity)));
        },
    });

    const ref = useRef<HTMLDivElement>(null);
    drag(ref.current);
    drop(ref.current);

    return (
        <div
        >
            <Tooltip title={entity.name}>
                <WTypography
                    sx={{
                        pl: 2,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    <span ref={ref} className={active ? 'smx-drop-target' : ''}>{entity.name}</span>
                </WTypography>
            </Tooltip>
        </div>
    );
}